module.exports = __webpack_public_path__ + "img/chromecast_webcast_art_small.7c1b054.png";